// Global site content: navigation, audiences, engagement models, footer.
import {
  Compass, TrendingUp, Share2, FlaskConical, Target, Handshake, Wrench,
  Building2, Globe2, Beaker, LineChart, Boxes, Users, ClipboardCheck, Repeat, Factory, Layers,
} from "lucide-react";

export const NAV = [
  { label: "Advisory", to: "/advisory" },
  { label: "Expertise", to: "/expertise" },
  { label: "Technical Hub", to: "/technical-hub" },
  { label: "Market Intelligence", to: "/market-intelligence" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const AUDIENCES = [
  {
    icon: Factory,
    title: "PU Systems Users & Manufacturers",
    body: "Sandwich panel, flexible foam, refrigeration, appliance and solar-heater manufacturers who need expert PU formulation support without hiring an in-house specialist.",
  },
  {
    icon: Layers,
    title: "Silicone Compound Users",
    body: "Companies buying ready silicone compounds who want to compound in-house to reduce cost, gain control and protect margins.",
  },
  {
    icon: Building2,
    title: "Business Owners & Senior Executives",
    body: "Independent perspective on growth opportunities, commercial challenges, market priorities and strategic decisions.",
  },
  {
    icon: Globe2,
    title: "International Industrial Companies",
    body: "Support for companies evaluating new countries, customers, applications, partners or routes to market.",
  },
  {
    icon: Beaker,
    title: "Chemical & Materials Businesses",
    body: "Commercial and technical-commercial insight across polyurethane, silicones, polymers and specialty chemicals.",
  },
  {
    icon: LineChart,
    title: "Investors & Strategic Buyers",
    body: "Independent market, commercial and technical perspectives when assessing industrial opportunities or investments.",
  },
  {
    icon: Boxes,
    title: "Distributors & B2B Organisations",
    body: "Support with portfolio development, market positioning, supplier strategy, channel development and commercial growth.",
  },
];

export const ENGAGEMENTS = [
  {
    icon: Target,
    title: "Strategic Advisory",
    body: "Focused independent input around a specific opportunity, challenge or management decision.",
  },
  {
    icon: ClipboardCheck,
    title: "Project-Based Consulting",
    body: "A defined commercial or technical-commercial question requiring structured research, analysis and recommendations.",
  },
  {
    icon: Repeat,
    title: "Retained Advisory",
    body: "Ongoing access to senior independent advice for executives, business owners, investors or commercial teams.",
  },
];

export const ADVISORY_ICONS = { Compass, TrendingUp, Share2, FlaskConical, Target, Handshake, Wrench };

export const FOOTER = {
  columns: [
    {
      title: "Consulting",
      links: [
        { label: "Polyurethane Consulting", to: "/polyurethane-consulting" },
        { label: "Silicone Consulting", to: "/silicone-consulting" },
        { label: "Technical Intelligence", to: "/technical-intelligence" },
        { label: "Market & Commercial Advisory", to: "/market-commercial-advisory" },
        { label: "Supplier & Distributor Advisory", to: "/supplier-distributor-advisory" },
      ],
    },
    {
      title: "Advisory",
      links: [
        { label: "Market Entry", to: "/advisory/market-entry-growth" },
        { label: "Commercial Strategy", to: "/advisory/commercial-strategy" },
        { label: "Distribution Strategy", to: "/advisory/distribution-strategy" },
        { label: "Industrial Advisory", to: "/advisory/industrial-advisory" },
        { label: "Strategic Projects", to: "/advisory/strategic-projects" },
      ],
    },
    {
      title: "Technical Intelligence",
      links: [
        { label: "Technical Hub", to: "/technical-hub" },
        { label: "Polyurethane", to: "/technical-hub/polyurethane" },
        { label: "Silicones", to: "/technical-hub/silicones" },
        { label: "PU Calculators", to: "/technical-hub/calculators" },
        { label: "Technical Resources", to: "/technical-hub/resources" },
      ],
    },
    {
      title: "MATRIVON",
      links: [
        { label: "About", to: "/about" },
        { label: "Market Intelligence", to: "/market-intelligence" },
        { label: "Insights", to: "/insights" },
        { label: "Resources", to: "/resources" },
        { label: "Contact", to: "/contact" },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Privacy Policy", to: "/privacy-policy" },
        { label: "Terms of Use", to: "/terms-of-use" },
        { label: "Technical Disclaimer", to: "/technical-disclaimer" },
        { label: "Affiliate Disclosure", to: "/affiliate-disclosure" },
      ],
    },
  ],
};

export const CONTACT = {
  email: "sonmez@matrivon.com",
  phone: "+971 50 773 2789",
};

export const AREAS_OF_INTEREST = [
  "Market Entry",
  "Commercial Strategy",
  "Distribution",
  "Industrial Advisory",
  "Technical Question",
  "Strategic Project",
  "Other",
];
